import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BannerApi, FilterBannerOptions } from 'api';

export const findBannerForTableList = createAsyncThunk(
  'banner/findBannerForTableList',
  async (option: FilterBannerOptions, { rejectWithValue }) => {
    try {
      const response = await BannerApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createBanner = createAsyncThunk(
  'banner/createBanner',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await BannerApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBanner = createAsyncThunk(
  'banner/updateBanner',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await BannerApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeBanner = createAsyncThunk(
  'banner/removeBanner',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await BannerApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  query: {},
};

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    reloadBanner(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findBannerForTableList.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
          infoBox: {
            name: item.name,
            img: item.avatar,
          },
        };
      });

      state.tableList = newData;
    });
  },
});

const { actions, reducer: bannerReducer } = bannerSlice;

export const { reloadBanner } = actions;

export default bannerReducer;
